import React from 'react'
import { connect } from 'react-redux'
import { Sticky } from 'react-sticky'
import { clearNotification } from '../actions/notificationActions'

class Notifier extends React.Component {
  componentDidUpdate() {
    // Fixes notification not appearing initially when scrolled down the page.
    window.scrollTo(window.scrollX, window.scrollY - 1)
    window.scrollTo(window.scrollX, window.scrollY + 1)
  }

  handleClose = () => {
    const { dispatch } = this.props
    dispatch(clearNotification())
  }

  render() {
    const { notification } = this.props
    if (!notification.message) return null

    return (
      <Sticky disableCompensation>
        {({ isSticky }) => (
          <div
            className={`alerts ${
              notification.style === 'error' ? 'alert-error' : 'alert-success'
            } ${isSticky ? 'alerts-sticky' : 'alerts-fixed-top'}`}
          >
            <div className="alert alert-dismissible" role="alert">
              <button
                className="close"
                type="button"
                onClick={this.handleClose}
              >
                <span className="icon icon-close" />
              </button>
              <div dangerouslySetInnerHTML={{ __html: notification.message }} />
            </div>
          </div>
        )}
      </Sticky>
    )
  }
}

export default connect(({ notification }) => ({ notification }))(Notifier)
